<template lang="pug">
  .messages-list
    .preloader(v-if="is_loading")
    .messages-scroller
      .messages-wrapper
        message-item(v-for="(message, i) in messages" :key="message.id" :message="message.attributes")
    small.dashed-link(v-if="has_unread_msg" @click="read_all_messages") прочитать все
    message-form(:chat_id="chat_id" @submit="createMessage", :socket_state="socket_state")
    //.env.text-muted
      small {{socket_state}}

    template(v-if="is_agent")
      hr
      .mb-3
        b-btn(size="sm" variant="light" @click="createInvoiceQuery") Запросить счет
      .mb-3
        b-btn(size="sm" variant="light" @click="createCancelQuery") Аннулировать заказ

</template>

<script>
import MessageForm from "./MessageForm";
import MessageItem from "./MessageItem";
import SocketState from "../common/SocketState";
export default {
name: "MessagesList",
  components: {SocketState, MessageItem, MessageForm},
  props: {
    chat_id: {
      type: [Number, String],
      default: undefined
    },
    role: {
      type: String,
      default: 'user',
    }
  },
  data(){
    return {
      socket_state: undefined,
      env: process.env.RAILS_ENV,
    }
  },
  computed:{
    is_agent(){
      return this.role === 'agent';
    },
    messages(){
      return this.$store.getters[`messages/allMessages`];
    },
    unread_messages(){
      return this.$store.getters[`messages/unreadMessages`];
    },
    has_unread_msg(){
      return this.unread_messages.length > 0
    },
    list_state(){
      return this.$store.state.messages.list_state;
    },
    is_loading(){
      return this.list_state === 'loading'
    },
  },
  channels: {
    MessagesChannel: {
      connected() {
        console.log('===== connected!');
        if (this.socket_state === 'disconnected') this.updateMessageList();
        this.socket_state = 'connected'
      },
      rejected() {
        console.log('===== rejected!');
        this.socket_state = 'rejected'
      },
      received(data) {
        console.log('===== received.', data);
        this.$store.commit('messages/addMessage', data.data)
      },
      disconnected() {
        console.log('===== disconnected!');
        this.socket_state = 'disconnected'
      },
    },
  },
  beforeMount() {
    this.$store.commit('messages/setListRole', this.role);
  },
  updated() {
    this.scroll_list_to_bottom();
  },
  mounted() {
    this.updateMessageList();
    this.$cable.subscribe({
      channel: 'MessagesChannel',
      chat_id: this.chat_id,
      room: 'public',
    });
  },
  methods:{
    updateMessageList(){
      let promise = this.$store.dispatch(`messages/getMessages`, {chat_id: this.chat_id});
      promise.then(this.scroll_list_to_bottom);
    },
    scroll_list_to_bottom(){
      let scroller = document.querySelector('.messages-scroller')
      scroller.scrollTop = scroller.scrollHeight - scroller.clientHeight;
    },
    createMessage(body, msg_type = 'text'){
      this.$store.dispatch(`messages/addMessage`, {
        body,
        msg_type,
        chat_id: this.chat_id,
      })
    },
    createInvoiceQuery(){
      this.createMessage('Прошу выставить счёт на оплату заказа.', 'query')
    },
    createCancelQuery(){
      if (confirm('Отправить запрос на отмену заказа?')) this.createMessage('Прошу аннулировать заказ.', 'query')
    },
    read_all_messages(){
      this.$store.dispatch('messages/readAllMessages', {
        chat_id: this.chat_id,
      })
    },
    // sendMessage: function() {
    //   this.$cable.perform({
    //     channel: 'ChatChannel',
    //     action: 'send_message',
    //     data: {
    //       content: this.message
    //     }
    //   });
    // },
  }
}
</script>

<style scoped>
 .messages-list{
   padding: 10px 0;
 }
 .messages-scroller{
   padding: 0;
   height: auto;
   max-height: 400px;
   overflow-y: scroll;
 }

 .dashed-link{
   font-size: 12px;
   opacity: .5;
   text-decoration: underline;
   text-decoration-style: dashed;
   cursor: pointer;
 }
</style>